import React, { useState, useRef } from 'react';

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const faqData = [
    {
      question: "¿Qué es el MUN?",
      answer: "El Modelo de las Naciones Unidas (MUN, por sus siglas en inglés) puede definirse como una simulación o representación de los distintos órganos del Sistema de Naciones Unidas, así como de otras organizaciones internacionales, en el que participan alumnos de escuelas secundarias y universidades. Es considerado como una herramienta educativa que busca promover los propósitos y principios de la Organización de las Naciones Unidas (ONU) y difundir su trabajo como principal foro para la resolución de conflictos. Por ello, se discuten temas como el mantenimiento de la paz, la defensa de los derechos humanos, la búsqueda de justicia internacional, la promoción del desarrollo económico y social, y el empoderamiento de mujeres y niñas, así como el uso pacífico de la energía atómica y la lucha contra cambio climático, por mencionar sólo algunos de los temas a tratar. En suma, MUN es una actividad transcultural y transformadora que permite a los estudiantes crecer académica y personalmente."
    },
    {
      question: "¿Cómo necesito para pertenecer a un equipo MUN?",
      answer: "Se requiere un nivel de compromiso y participación activa de los estudiantes"
    },
    {
      question: "¿Qué tiempo tendría que dedicar si pertenezco al MUN?",
      answer: "4 horas semanales divididas en dos entrenamientos por semana."
    },
    {
      question: "¿Qué es el Dual Diploma?",
      answer: "Es una certificación de high school, emitida por las autoridades de Estados Unidos correspondientes, y con validez internacional. El programa completo se cursa en línea, en un modelo autogestionado, siendo flexible con el avance de cada alumno. Los maestros estadounidenses a distancia se encargan de calificaciones, monitoreo y seguimiento. El programa de diploma dual puede cursarse durante los últimos  años de secundaria (del 9-12) El certificado de high school lo emite el colegio Catholic Virtual School. \n\n Proponemos un programa de 5 créditos académicos, compuestos por 10 materias semestrales en total (cada materia semestral = 0.5 crédito). El certificado avala el bachillerato estadounidense, como si el alumno hubiera cursado la totalidad de los años escolares en Estados Unidos, y tiene un reconocimiento internacional."
    },
    {
      question: "¿Qué tiempo tendría que dedicar si llevo el Doble diplomado americano?",
      answer: "El estudiante debe dedicar un promedio de 1 hora al día."
    },
    {
      question: "¿Qué cursos se llevan el doble diplomado americano?",
      answer: "Artificial Intelligence/ Robotics/ Marine Science/ Renewable Energy/ US Government/ Economics/ Statistics A and B/ English 1A 1B."
    },
    {
      question: "¿Cuál es el costo del doble diplomado americano?",
      answer: "Costo por credito \n\n Cada medio credito (0.5) tiene un costo de $295"
    },
    {
      question: "¿Qué es coded / steam?",
      answer: "Es un Programa de Tecnología en la Educación.\n\nEl mundo profesional y la vida nos permiten materializar sueños a través de diferentes herramientas, no hay imposibles a través de STEAM & CODING y queremos hacer creer a todas las generaciones que todo es posible a través de la tecnología.\n\nNuestra Misión es promover la concientización, brindar educación y fomentar el desarrollo de estudiantes, instituciones y educadores de todo el mundo"
    },
    {
      question: "¿Qué actividades realizan CODED /STEAM?",
      answer: "S C I E N C E\n\nCoding day: the Digital Hub  / Physics of Disney at Hollywood Studio\n\nT E C H N O L O G Y\n\nRobotics in Automated Systems / Transformers 6-degree of Freedom at Universal Studios\n\nE N G I N E E R I N G\n\nAi & Machine Learning coding chatbots / Virtual Space Rovers Robotics at NASA\n\nA R T S\n\nColony Layout & Infrastructure: Urban Planning / Space Suit Design at NASA\n\nM A T H E M A T I C S\n\nEnvironmental Engineering at Epic Universe"
    }
  ];

  return (
    <section className="bg-white py-20 px-6 md:px-12 lg:px-16 font-sans">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-24">
        
        {/* Header Column */}
        <div className="lg:col-span-5">
          {/* Badge */}
          <div className="inline-block px-8 py-1.5 border border-gray-400 rounded-full mb-6 bg-white/80 backdrop-blur-sm">
            <span className="text-gray-600 text-sm font-medium tracking-wide">Centro de Ayuda</span>
          </div>

          {/* Title */}
          <h2 className="text-4xl md:text-5xl font-bold text-[#1a3b5c] mb-6 tracking-tight leading-tight">
            Preguntas <br /> Frecuentes
          </h2>

          {/* Subtitle */}
          <p className="text-gray-600 text-lg leading-relaxed font-light">
            Resolvemos tus dudas principales sobre nuestros programas y servicios educativos.
          </p>
        </div>

        {/* Questions List Column */}
        <div className="lg:col-span-7">
          <div className="divide-y divide-gray-200">
            {faqData.map((item, index) => {
              const isOpen = openIndex === index;
              // eslint-disable-next-line react-hooks/rules-of-hooks
              const contentRef = useRef(null);

              return (
                <div key={index} className="py-6">
                  <button
                    className="flex justify-between items-center w-full text-left focus:outline-none group"
                    onClick={() => toggleFAQ(index)}
                  >
                    <span className={`text-xl font-medium transition-colors duration-300 ${isOpen ? 'text-[#5B9BB0]' : 'text-gray-900 group-hover:text-[#5B9BB0]'}`}>
                      {item.question}
                    </span>
                    <span className={`ml-6 flex-shrink-0 transition-transform duration-300 ease-in-out ${isOpen ? 'transform rotate-180' : ''}`}>
                      {/* Arrow Icon */}
                      <svg className={`w-6 h-6 ${isOpen ? 'text-[#5B9BB0]' : 'text-gray-400 group-hover:text-[#5B9BB0]'}`} fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                      </svg>
                    </span>
                  </button>

                  {/* Answer Dropdown with smooth transition */}
                  <div
                    ref={contentRef}
                    style={{
                      maxHeight: isOpen ? `${contentRef.current.scrollHeight}px` : '0px',
                      opacity: isOpen ? 1 : 0
                    }}
                    className="overflow-hidden transition-all duration-500 ease-in-out"
                  >
                    <div className="pt-4 pr-12">
                      <p className="text-gray-600 text-base leading-relaxed font-light whitespace-pre-line">
                        {item.answer}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
  );
};

export default FAQ;